<mat-sidenav-container class="reports-container">
  <mat-sidenav #sidenav mode="side" opened class="sidenav-padding">
    <app-new-workflow-request-button></app-new-workflow-request-button>

    <div class="sidenav-section">
      <h4 class="sidenav-heading">Reports</h4>
      <div class="sidenav-actions">
        <button mat-button color="primary" (click)="createNewReport()">
          <mat-icon>add</mat-icon> New Report
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>

    <div class="sidenav-section">
      <h4 class="sidenav-heading">Info</h4>
      <p class="sidenav-tip">Create reports to filter and export data from any entity in the system.</p>
      <p class="sidenav-tip">Click a report name to preview results.</p>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="reports-content">
      <div class="reports-header">
        <h2>My Reports</h2>
        <button mat-raised-button color="primary" (click)="createNewReport()">
          <mat-icon>add</mat-icon> New Report
        </button>
      </div>

      @if (reports.length === 0) {
        <div class="empty-state">
          <mat-icon class="empty-icon">assessment</mat-icon>
          <h3>No reports yet</h3>
          <p>Create your first report to filter and export data from contracts, parties, and more.</p>
          <button mat-raised-button color="primary" (click)="createNewReport()">
            <mat-icon>add</mat-icon> Create Report
          </button>
        </div>
      } @else {
        <table mat-table [dataSource]="reports" class="reports-table">

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Report Name</th>
            <td mat-cell *matCellDef="let report">
              <a class="report-name-link" (click)="runReport(report)">
                {{ report.name }}
              </a>
            </td>
          </ng-container>

          <!-- Entity Type Column -->
          <ng-container matColumnDef="entityType">
            <th mat-header-cell *matHeaderCellDef>Data Source</th>
            <td mat-cell *matCellDef="let report">
              <span class="entity-type-cell">
                <mat-icon class="entity-type-icon">{{ getEntityIcon(report.entityType) }}</mat-icon>
                {{ getEntityLabel(report.entityType) }}
              </span>
            </td>
          </ng-container>

          <!-- Owner Column -->
          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Owner</th>
            <td mat-cell *matCellDef="let report">{{ report.owner }}</td>
          </ng-container>

          <!-- Updated Column -->
          <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef>Last Modified</th>
            <td mat-cell *matCellDef="let report">{{ formatDate(report.updatedAt) }}</td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let report">
              <div class="actions-cell">
                <button mat-icon-button color="primary" (click)="runReport(report)" matTooltip="Run Report">
                  <mat-icon>play_arrow</mat-icon>
                </button>
                <button mat-icon-button (click)="editReport(report)" matTooltip="Edit in Builder">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button [matMenuTriggerFor]="moreMenu" matTooltip="More actions">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #moreMenu="matMenu">
                  <button mat-menu-item (click)="duplicateReport(report)">
                    <mat-icon>content_copy</mat-icon> Duplicate
                  </button>
                  <button mat-menu-item (click)="deleteReport(report)">
                    <mat-icon color="warn">delete</mat-icon> Delete
                  </button>
                </mat-menu>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="report-row"></tr>
        </table>
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
